/**
 * New Drops countdown.
 * Drives any element with [data-new-drops-countdown] and a
 * [data-target-date] ISO datetime attribute. Updates child nodes
 * carrying data-countdown-days / -hours / -minutes / -seconds,
 * and flips the host's data-countdown-state to "expired" when done.
 */
class NewDropsCountdown extends HTMLElement {
  connectedCallback() {
    this.targetDate = new Date(this.dataset.targetDate).getTime();

    this.dayEl = this.querySelector('[data-countdown-days]');
    this.hourEl = this.querySelector('[data-countdown-hours]');
    this.minEl = this.querySelector('[data-countdown-minutes]');
    this.secEl = this.querySelector('[data-countdown-seconds]');

    if (Number.isNaN(this.targetDate)) return;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.targetDate - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.setState('expired');
      this.render(0, 0, 0, 0);
      this.dispatchEvent(new CustomEvent('new-drops:expired', { bubbles: true }));
      return;
    }

    const seconds = Math.floor(remaining / 1000) % 60;
    const minutes = Math.floor(remaining / (1000 * 60)) % 60;
    const hours = Math.floor(remaining / (1000 * 60 * 60)) % 24;
    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));

    this.render(days, hours, minutes, seconds);
  }

  render(days, hours, minutes, seconds) {
    const pad = (n) => String(n).padStart(2, '0');
    if (this.dayEl) this.dayEl.textContent = days;
    if (this.hourEl) this.hourEl.textContent = pad(hours);
    if (this.minEl) this.minEl.textContent = pad(minutes);
    if (this.secEl) this.secEl.textContent = pad(seconds);
  }

  setState(state) {
    const host = this.closest('[data-countdown-state]') || this;
    host.dataset.countdownState = state;
  }
}

customElements.define('new-drops-countdown', NewDropsCountdown);
